import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import Project from './views/Project.vue'
import Projects from './views/Projects.vue'
import Account from './views/Account.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/app/',
      name: 'home',
      component: Home
    },
    {
      path: '/app/account',
      name: 'account',
      component: Account
    },
    {
      path: '/app/projects',
      name: 'projects',
      component: Projects
    },
    {
      path: '/p/:project_slug',
      name: 'project',
      component: Project
    },
    {
      path: '/f/:factsheet_id',
      name: 'factsheet',
      component: () => import('./views/factsheet/Factsheet.vue')
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('./views/Login.vue')
    },
    {
      path: '/login/ldr',
      name: 'login-ldr',
      component: () => import('./views/LoginLdr.vue')
    },
    {
      path: '/idh',
      name: 'home-idh',
      component: () => import('./views/LoginLdr.vue')
    },
    {
      path: '/logout',
      name: 'logout',
      component: () => import('./views/Logout.vue')
    },
    {
      path: '/signup',
      name: 'signup',
      component: () => import('./views/Signup.vue')
    }
    // ,
    // {
    //   path: '/test',
    //   name: 'test',
    //   // route level code-splitting
    //   // this generates a separate chunk (about.[hash].js) for this route
    //   // which is lazy-loaded when the route is visited.
    //   component: () => import(/* webpackChunkName: "about" */ './views/About.vue')
    // }
  ]
  ,
  scrollBehavior (to, from, savedPosition) {
    if (to.hash) {
      return {
        selector: to.hash
      }    
    } else {
      return { 
        x: 0, 
        y: 0
      }
    }
  }
})
